import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tooltip } from '@utex/ui-kit';
import { List } from '@utex/ui-kit/desktop';
import { NavItem } from '../NavItem';

export interface LinksProps {
  onAccountClick: () => void;
  passportLink: string;
  onPartnershipClick: () => void;
  onTradingClick: () => void;
}

export function Links(props: LinksProps) {
  const { onAccountClick, passportLink, onPartnershipClick, onTradingClick } = props;
  const { t } = useTranslation('sidenavlinks');

  return (
    <>
      <Box display={{ tablesktop: 'none' }}>
        <NavItem
          view="hint"
          size="XS"
          href="/investments/open-investment"
          onClick={(e: SyntheticEvent) => {
            e.preventDefault();
            onAccountClick();
          }}
          data-testid="account-link"
        >
          {t('sidenavlinks:Accounts')}
        </NavItem>

        <NavItem view="hint" size="XS" href={passportLink} target="_blank" data-testid="kyc-link">
          {t('sidenavlinks:Profile, Security, KYC')}
        </NavItem>
      </Box>

      <NavItem
        view="hint"
        size="XS"
        href="https://partners.utex.io"
        onClick={(e: SyntheticEvent) => {
          e.preventDefault();
          onPartnershipClick();
        }}
        data-testid="partnership-link"
      >
        {t('sidenavlinks:Partnership')}
      </NavItem>

      <Box display={{ phonablet: 'none' }}>
        <NavItem
          view="hint"
          size="XS"
          href="/trading"
          onClick={(e: SyntheticEvent) => {
            e.preventDefault();
            onTradingClick();
          }}
          data-testid="trading-link"
        >
          {t('sidenavlinks:Trading')}
        </NavItem>
      </Box>

      <Tooltip
        position="top"
        width={284}
        offset={8}
        isArrow={false}
        padding={[10, 0]}
        trigger={
          <NavItem view="hint" size="XS" isExpand={true} as="button" data-testid="documents-link">
            {t('sidenavlinks:Documents')}
          </NavItem>
        }
      >
        <List paddingItems="1rem 1.6rem">
          <List.ItemButton href={t('sidenavlinks:licence_agreement_href')} as="a" target="_blank">
            {t('sidenavlinks:Licence Agreement')}
          </List.ItemButton>

          <List.ItemButton href={t('sidenavlinks:risk_statements_href')} as="a" target="_blank">
            {t('sidenavlinks:Risk Statements')}
          </List.ItemButton>

          <List.ItemButton href={t('sidenavlinks:privacy_policy_href')} as="a" target="_blank">
            {t('sidenavlinks:Privacy Policy')}
          </List.ItemButton>
        </List>
      </Tooltip>
    </>
  );
}
